export const LocalStorage = {
  clearAll() {
    window.localStorage.clear();
  },

  get(key) {
    let value = null;
    try {
      value = window.localStorage.getItem(key);
      return typeof value === 'string' ? JSON.parse(value) : value;
    } catch (error) {
      return value;
    }
  },

  set(key, value) {
    if (typeof value === 'object') {
      window.localStorage.setItem(key, JSON.stringify(value));
    } else {
      window.localStorage.setItem(key, value);
    }
    window.localStorage.setItem(key + ':ts', Date.now().toString());
  },

  setFlag(store, accountId, key, expiry = 24 * 60 * 60 * 1000) {
    const storeName = accountId ? `${store}::${accountId}` : store;

    const rawValue = window.localStorage.getItem(storeName);
    const parsedValue = rawValue ? JSON.parse(rawValue) : {};

    parsedValue[key] = Date.now() + expiry;

    window.localStorage.setItem(storeName, JSON.stringify(parsedValue));
  },

  getFlag(store, accountId, key) {
    const storeName = store ? `${store}::${accountId}` : store;

    const rawValue = window.localStorage.getItem(storeName);
    const parsedValue = rawValue ? JSON.parse(rawValue) : {};

    return parsedValue[key] && parsedValue[key] > Date.now();
  },

  remove(key) {
    window.localStorage.removeItem(key);
    window.localStorage.removeItem(key + ':ts');
  },

  updateJsonStore(storeName, key, value) {
    try {
      const storedValue = this.get(storeName) || {};
      storedValue[key] = value;
      this.set(storeName, storedValue);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Error updating JSON store in localStorage', e);
    }
  },

  getFromJsonStore(storeName, key) {
    try {
      const storedValue = this.get(storeName) || {};
      return storedValue[key] || null;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Error getting value from JSON store in localStorage', e);
      return null;
    }
  },

  deleteFromJsonStore(storeName, key) {
    try {
      const storedValue = this.get(storeName);
      if (storedValue && key in storedValue) {
        delete storedValue[key];
        this.set(storeName, storedValue);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Error deleting entry from JSON store in localStorage', e);
    }
  },

  // Pass B H9/H10 — account-scoped JSON store helpers.
  //
  // The previous `updateJsonStore(storeName, key, value)` keyed the
  // inner store by the caller's `key` directly. For `DRAFT_MESSAGES` and
  // `MESSAGE_REPLY_TO` the caller's `key` was a conversationId, so a
  // collision was possible across accounts (the same numeric conversationId
  // exists in different accounts and the LocalStorage record was global).
  //
  // The account-scoped variants prefix the top-level localStorage key with
  // the current accountId, isolating the JSON store per tenant. New code
  // should use these helpers for per-tenant UI state. Legacy non-scoped
  // accessors are retained for backwards compatibility with code that
  // stores keys it has already validated as globally unique (e.g.
  // `recentSearches`).
  accountScopedStoreName(storeName, accountId) {
    return accountId ? `${storeName}::${accountId}` : storeName;
  },

  updateAccountScopedJsonStore(storeName, accountId, key, value) {
    return this.updateJsonStore(this.accountScopedStoreName(storeName, accountId), key, value);
  },

  getFromAccountScopedJsonStore(storeName, accountId, key) {
    return this.getFromJsonStore(this.accountScopedStoreName(storeName, accountId), key);
  },

  deleteFromAccountScopedJsonStore(storeName, accountId, key) {
    return this.deleteFromJsonStore(this.accountScopedStoreName(storeName, accountId), key);
  },
};
